import { React, useEffect } from "react";
import ChatWindow from "./components/chat-window";
import {
  ChatButton,
  ChatInvite,
  ChatInviteRemake,
} from "./components/chat-button";
import { useState } from "react";
import { setSessionItem, getSessionItem } from "./utility/chatUtility";

if (window.screen.width < 500) {
  var isMobile = true;
} else {
  var isMobile = false;
}

export default function ChatApp() {
  const [openChat, setOpenChat] = useState(false);
  const [newMsgNum, setNewMsgNum] = useState(0);
  const [cssLoaded, setCssLoaded] = useState(false);
  const [envVariables, setEnvVariables] = useState(null);

  const configBucket = process.env.REACT_APP_ROOT_CSS_BUCKET;

  const params = new URLSearchParams(window.location.search);
  const agentId = params.get("agentId") === "null" ? null : params.get("agentId");
  const environmentId = params.get("environmentId") === "null" ? null : params.get("environmentId");
  const connectorWebhook = params.get("connectorWebhook");
  const projectId = params.get("projectId") === "null" ? null : params.get("projectId");
  const location = params.get("locationId") === "null" ? null : params.get("locationId");
  const domain = params.get("domain") === null || params.get("domain") === "null" ? "connexcare.com" : params.get("domain");

  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `https://storage.googleapis.com/${configBucket}/${agentId}_${environmentId}.css?timestamp=${new Date().getTime()}`;
    link.onload = () => setCssLoaded(true);
    document.head.appendChild(link);

    // Fetch configs from GCS
    const agentConfigUrl = `https://storage.googleapis.com/${configBucket}/agent_configs/${agentId}_${environmentId}.json?timestamp=${new Date().getTime()}`;
    fetch(agentConfigUrl)
      .then(response => response.json())
      .then(data => {
        data.agentId = agentId;
        data.environmentId = environmentId;
        data.connectorWebhook = connectorWebhook;
        data.projectId = projectId;
        data.location = location;
        data.domain = domain;

        setSessionItem("language", data.startingLanguage);
        setEnvVariables(data);
      })
      .catch(error => {
        console.error('Error fetching agent config file:', error);
      });

    return () => {
      document.head.removeChild(link);
    };
  }, []);

  if (!cssLoaded || !envVariables) {
    return null;
  }

  if (!getSessionItem("fontSize")) {
    setSessionItem("fontSize", "Small");
  }

  const setOptionWindow = () => {
    setOpenChat((prev) => !prev);
    window.parent.postMessage("handleWindowChange", "*");
  };
  return (
    <>
      <meta
        name="viewport"
        content={
          navigator.userAgent.indexOf('iPhone') > -1
            ? "initial-scale=1, width=device-width, maximum-scale=1"
            : "initial-scale=1, width=device-width"
        }
      />

      <div
        className="main-container"
        style={{
          position: "relative",
          padding: "30px",
          height: "100%",
          width: "100%",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between"

        }}
      >
        <div className="window-container-main" style={{
          // height: "93d%",
          position: "fixed",
          bottom: "90px",
          right: "30px",
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          height: "calc(95vh - 90px)",
        }}>
          <ChatWindow
            env={envVariables}
            openWindow={setOptionWindow}
            chatWindowStatus={openChat}
            setNewMsgNum={setNewMsgNum}
          />
        </div>
        <div className="button-container-main" style={{
          position: "absolute",
          bottom: "35px",
          right: "35px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          height: "7%"
        }}>
          <ChatButton
            env={envVariables}
            openWindow={setOptionWindow}
            chatWindowStatus={openChat}
            newMsgNum={newMsgNum}
          />
        </div>
        <ChatInviteRemake
          env={envVariables}
          openWindow={setOptionWindow}
          msgHistory={JSON.parse(sessionStorage.getItem("msgHistory"))}
          lang={!getSessionItem("language") ? envVariables.startingLanguage : getSessionItem("language")}
        />
      </div>
    </>
  );
}
''